module.exports = __webpack_public_path__ + "img/MoonSword 4b.7bd12c28.png";